/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestCrazyGamesOptions
 */
export interface FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestCrazyGamesOptions {
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestCrazyGamesOptions
     */
    AccessToken: string;
}

/**
 * Check if a given object implements the FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestCrazyGamesOptions interface.
 */
export function instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestCrazyGamesOptions(value: object): value is FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestCrazyGamesOptions {
    if (!('AccessToken' in value) || value['AccessToken'] === undefined) return false;
    return true;
}

export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestCrazyGamesOptionsFromJSON(json: any): FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestCrazyGamesOptions {
    return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestCrazyGamesOptionsFromJSONTyped(json, false);
}

export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestCrazyGamesOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestCrazyGamesOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'AccessToken': json['AccessToken'],
    };
}

export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestCrazyGamesOptionsToJSON(json: any): FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestCrazyGamesOptions {
    return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestCrazyGamesOptionsToJSONTyped(json, false);
}

export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestCrazyGamesOptionsToJSONTyped(value?: FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestCrazyGamesOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'AccessToken': value['AccessToken'],
    };
}

